/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Category } from './Category';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
    CategoryToJSONTyped,
} from './Category';
import type { Email } from './Email';
import {
    EmailFromJSON,
    EmailFromJSONTyped,
    EmailToJSON,
    EmailToJSONTyped,
} from './Email';
import type { SubCategory } from './SubCategory';
import {
    SubCategoryFromJSON,
    SubCategoryFromJSONTyped,
    SubCategoryToJSON,
    SubCategoryToJSONTyped,
} from './SubCategory';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';

/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    status?: JobStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    type?: JobTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    experienceLevel?: JobExperienceLevelEnum;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    salaryStart?: number;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    salaryEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    requirements?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    benefits?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    companyDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    companyEmail?: string;
    /**
     * 
     * @type {Date}
     * @memberof Job
     */
    validity?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Job
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Job
     */
    updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    domainId?: number;
    /**
     * 
     * @type {Domain}
     * @memberof Job
     */
    Domain?: Domain;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    categoryId?: number;
    /**
     * 
     * @type {Category}
     * @memberof Job
     */
    Category?: Category;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    subCategoryId?: number;
    /**
     * 
     * @type {SubCategory}
     * @memberof Job
     */
    SubCategory?: SubCategory;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    companyId?: number;
    /**
     * 
     * @type {Array<Email>}
     * @memberof Job
     */
    Emails?: Array<Email>;
}


/**
 * @export
 */
export const JobStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED',
    Closed: 'CLOSED'
} as const;
export type JobStatusEnum = typeof JobStatusEnum[keyof typeof JobStatusEnum];

/**
 * @export
 */
export const JobTypeEnum = {
    Parttime: 'PARTTIME',
    Fulltime: 'FULLTIME',
    Freelance: 'FREELANCE',
    Contract: 'CONTRACT',
    Internship: 'INTERNSHIP'
} as const;
export type JobTypeEnum = typeof JobTypeEnum[keyof typeof JobTypeEnum];

/**
 * @export
 */
export const JobExperienceLevelEnum = {
    Entry: 'ENTRY',
    Mid: 'MID',
    Senior: 'SENIOR',
    Lead: 'LEAD',
    Executive: 'EXECUTIVE'
} as const;
export type JobExperienceLevelEnum = typeof JobExperienceLevelEnum[keyof typeof JobExperienceLevelEnum];


/**
 * Check if a given object implements the Job interface.
 */
export function instanceOfJob(value: object): value is Job {
    return true;
}

export function JobFromJSON(json: any): Job {
    return JobFromJSONTyped(json, false);
}

export function JobFromJSONTyped(json: any, ignoreDiscriminator: boolean): Job {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'location': json['location'] == null ? undefined : json['location'],
        'status': json['status'] == null ? undefined : json['status'],
        'type': json['type'] == null ? undefined : json['type'],
        'experienceLevel': json['experienceLevel'] == null ? undefined : json['experienceLevel'],
        'salaryStart': json['salaryStart'] == null ? undefined : json['salaryStart'],
        'salaryEnd': json['salaryEnd'] == null ? undefined : json['salaryEnd'],
        'description': json['description'] == null ? undefined : json['description'],
        'requirements': json['requirements'] == null ? undefined : json['requirements'],
        'benefits': json['benefits'] == null ? undefined : json['benefits'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companyDesc': json['companyDesc'] == null ? undefined : json['companyDesc'],
        'companyEmail': json['companyEmail'] == null ? undefined : json['companyEmail'],
        'validity': json['validity'] == null ? undefined : (new Date(json['validity'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'domainId': json['domainId'] == null ? undefined : json['domainId'],
        'Domain': json['Domain'] == null ? undefined : DomainFromJSON(json['Domain']),
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'Category': json['Category'] == null ? undefined : CategoryFromJSON(json['Category']),
        'subCategoryId': json['subCategoryId'] == null ? undefined : json['subCategoryId'],
        'SubCategory': json['SubCategory'] == null ? undefined : SubCategoryFromJSON(json['SubCategory']),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'Emails': json['Emails'] == null ? undefined : ((json['Emails'] as Array<any>).map(EmailFromJSON)),
    };
}

  export function JobToJSON(json: any): Job {
      return JobToJSONTyped(json, false);
  }

  export function JobToJSONTyped(value?: Job | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'location': value['location'],
        'status': value['status'],
        'type': value['type'],
        'experienceLevel': value['experienceLevel'],
        'salaryStart': value['salaryStart'],
        'salaryEnd': value['salaryEnd'],
        'description': value['description'],
        'requirements': value['requirements'],
        'benefits': value['benefits'],
        'companyName': value['companyName'],
        'companyDesc': value['companyDesc'],
        'companyEmail': value['companyEmail'],
        'validity': value['validity'] == null ? undefined : ((value['validity']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'domainId': value['domainId'],
        'Domain': DomainToJSON(value['Domain']),
        'categoryId': value['categoryId'],
        'Category': CategoryToJSON(value['Category']),
        'subCategoryId': value['subCategoryId'],
        'SubCategory': SubCategoryToJSON(value['SubCategory']),
        'companyId': value['companyId'],
        'Emails': value['Emails'] == null ? undefined : ((value['Emails'] as Array<any>).map(EmailToJSON)),
    };
}

